import classNames from 'classnames'
import React from 'react'
import { Dropdown } from 'react-bootstrap'

import useAppSelector from '../../../../../hooks/useAppSelector'
import { useAuth } from '../../../../../hooks/useAuth'
import { useUserGroups } from '../../../../../hooks/useUserGroups'
import { isDevelopment } from '../../../../../lib/helpers/envHelpers'
import { truncateText } from '../../../../../lib/helpers/helperFunctions'
import { selectCurrentGroup } from '../../../../../redux/slices/session'
import CompanyTypeIcon from '../../../../misc/CompanyIcon/CompanyTypeIcon'

const UserGroups: React.FC = () => {
  const currentGroup = useAppSelector(selectCurrentGroup)
  const groups = useUserGroups()
  const { updateGroupContext } = useAuth()

  if (!groups.length) {
    return null
  }

  return (
    <section>
      <div className="ps-3">Group</div>

      {groups.map((group) => (
        <Dropdown.Item
          onClick={() => updateGroupContext({ group: group['@id'] })}
          key={group.id}
          title={isDevelopment() ? `ID: ${group.id.toString()}` : undefined}
          className={classNames('d-flex align-items-center gap-2', {
            active: group.id === currentGroup?.id,
          })}
        >
          <CompanyTypeIcon
            companyTypeCode="other"
            style={{ width: '16px', height: '16px' }}
          />

          {truncateText(group.name, { maxLength: 50 })}
        </Dropdown.Item>
      ))}
      <Dropdown.Divider />
    </section>
  )
}

export default UserGroups
